import {Directive, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';

@Directive({
    selector: '[datepickerFocusTrap]',
    exportAs: 'datepicker-focus-trap'
})

export class DatePickerFocusTrap implements OnDestroy, OnInit {
    KEYCODE_TAB: number = 9;

    constructor(
        private hostElement: ElementRef
    ) {}

    ngOnInit() {
      this.focusToFirstElementOfDatePicker()
    }

    ngOnDestroy() {}

    focusToFirstElementOfDatePicker(){
      setTimeout(() => {
        const focusableEls1 = this.hostElement.nativeElement.querySelectorAll(
          '[id="current"]' 
          );
          const focusableEls = Array.from(focusableEls1)
          .filter( (el: any) => !el.disabled);
          let firstElementFocus : any = focusableEls[0];  
          // console.log('=========>fir', this.hostElement.nativeElement, firstElementFocus)
          firstElementFocus.focus({ preventScroll:true });
      }, 300)
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent): any {
      // console.log('==================focus trap', e)
        if (e.keyCode === 9 || e.keyCode === this.KEYCODE_TAB) {
            const focusableEls1 = this.hostElement.nativeElement.querySelectorAll(
                '[id="current"],[id="5-6-grid"],[id="3-3-grid"],[id="3-2-grid"]' 
              );
              const focusableEls = Array.from(focusableEls1)
                .filter( (el: any) => !el.disabled);
              const firstFocusableEl: any = focusableEls[0];  
              const lastFocusableEl: any = focusableEls[focusableEls.length - 1];
              
              // console.log(firstFocusableEl, lastFocusableEl)

              this.hostElement.nativeElement.addEventListener('keydown', (e : any) => {
                var isTabPressed = e.keyCode === 9; // isTabPressed

                // console.log(isTabPressed)
                if (!isTabPressed) return;
          
                if ( e.shiftKey ) /* shift + tab */ {
                  if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus({ preventScroll:true });
                    e.preventDefault();
                  }
                } else /* tab */ {
                  if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus({ preventScroll:true });
                    e.preventDefault();
                  }
                }
              });
        }
        // if (e.keyCode === 13 || e.key === 'Enter') {
        //   this.focusToFirstElementOfDatePicker()
        // }
    }
}